import { createAction } from "redux-actions";
import { ICourse } from "../../App/types/common";
import { mergeActionDefinitions } from "../../utils";

export const dashboardActions = mergeActionDefinitions("Dashboard", {
  fetchAllDashboardData: [],
  fetchCourseCompletionAnalytics: ["isClass", "courseId", "objectId"],
  handleFetchAllDashboardDataFailure: ["error"],
  handleFetchAllDashboardDataSuccess: ["courses", "classes", "editableByUser", "failedCoursesIds", "scormPackages"],
  handleFetchCourseCompletionAnalyticsFailure: ["error"],
  handleFetchCourseCompletionAnalyticsSuccess: ["analytics"],
  mount: [],
  unmount: [],
});

export const LIMIT_COURSES = 20;
export interface ISearchCoursesPayload {
  courses: ICourse[];
  courseIds: string[];
  failedCoursesIds: string[];
}

export interface ILoadCoursesPayload {
  courses: ICourse[];
  failedCoursesIds: string[];
}

export type DashboardAction =
  | "DASHBOARD/LOAD_ALL_COURSES"
  | "DASHBOARD/LOAD_MORE_COURSES"
  | "DASHBOARD/HANDLE_LOAD_MORE_COURSES_SUCCESS"
  | "DASHBOARD/HANDLE_LOAD_MORE_COURSES_FAILURE"
  | "DASHBOARD/HANDLE_SEARCH_COURSES_BY_NAME_FAILURE"
  | "DASHBOARD/HANDLE_SEARCH_COURSES_BY_NAME_SUCCESS"
  | "DASHBOARD/SEARCH_COURSES_BY_NAME";

export const LOAD_ALL_COURSES: DashboardAction = "DASHBOARD/LOAD_ALL_COURSES";
export const LOAD_MORE_COURSES: DashboardAction = "DASHBOARD/LOAD_MORE_COURSES";
export const HANDLE_LOAD_MORE_COURSES_SUCCESS: DashboardAction = "DASHBOARD/HANDLE_LOAD_MORE_COURSES_SUCCESS";
export const HANDLE_LOAD_MORE_COURSES_FAILURE: DashboardAction = "DASHBOARD/HANDLE_LOAD_MORE_COURSES_FAILURE";
export const SEARCH_COURSES_BY_NAME: DashboardAction = "DASHBOARD/SEARCH_COURSES_BY_NAME";
export const HANDLE_SEARCH_COURSES_BY_NAME_SUCCESS: DashboardAction = "DASHBOARD/HANDLE_SEARCH_COURSES_BY_NAME_SUCCESS";
export const HANDLE_SEARCH_COURSES_BY_NAME_FAILURE: DashboardAction = "DASHBOARD/HANDLE_SEARCH_COURSES_BY_NAME_FAILURE";

export const loadAllCourses = createAction<void>(LOAD_ALL_COURSES);
export const loadMoreCourses = createAction<void>(LOAD_MORE_COURSES);
export const handleLoadMoreCoursesSuccess = createAction<ILoadCoursesPayload>(HANDLE_LOAD_MORE_COURSES_SUCCESS);
export const handleLoadMoreCoursesFailure = createAction<{ message: string }>(HANDLE_LOAD_MORE_COURSES_FAILURE);
export const searchCoursesByName = createAction<string>(SEARCH_COURSES_BY_NAME);
export const handleSearchCoursesByNameSuccess = createAction<ISearchCoursesPayload>(
  HANDLE_SEARCH_COURSES_BY_NAME_SUCCESS
);
export const handleSearchCoursesByNameFailure = createAction<{
  message: string;
}>(HANDLE_SEARCH_COURSES_BY_NAME_FAILURE);
